import React, { useState } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import SingleURLPage from "./SingleURLPage";
import BatchURLSPage from "./BatchURLSPage";
import ProgressBar from "../components/ProgressBar";



const Home = ({ setShowAlert,batchType,setBatchType,BatchTypeDict,setAlertMessage,flap,isSingle,isBatch,user,refreshQuota }) => {
  const [loading, setLoading] = useState(false);
  const [progressLoading, setProgressLoading] = useState(false);

  const [progressPercentage, setProgressPercentage] = useState(0);


  return (
    <div className="main_container">
      {isSingle ? <Tabs forceRenderTabPanel={true}>
        <TabList>
          <Tab>Single Address</Tab>
          <Tab>Batch Process</Tab>
        </TabList>

        <TabPanel>
          <SingleURLPage
            setShowAlert={setShowAlert}
            setAlertMessage={setAlertMessage}
            setLoading={setLoading}
            refreshQuota={refreshQuota}
            flap={flap}
            isSingle={isSingle}
            user={user}
          />
        </TabPanel>

        <TabPanel>
          <BatchURLSPage
          batchType={batchType}
          BatchTypeDict={BatchTypeDict}
          setBatchType={setBatchType}
            setShowAlert={setShowAlert}
            setAlertMessage={setAlertMessage}
            setLoading={setLoading}
            setProgressLoading={setProgressLoading}
            progressPercentage={progressPercentage}
            setProgressPercentage={setProgressPercentage}
            refreshQuota={refreshQuota}
            flap={flap}
            isBatch={isBatch} 
            user={user}
          />
        </TabPanel>
      </Tabs>:<Tabs forceRenderTabPanel={true}>
        <TabList>
          <Tab>File Upload</Tab>
        </TabList>
        <TabPanel>
          <BatchURLSPage
          batchType={batchType}
          BatchTypeDict={BatchTypeDict}
          setBatchType={setBatchType}
            setShowAlert={setShowAlert}
            setAlertMessage={setAlertMessage}
            setLoading={setLoading}
            setProgressLoading={setProgressLoading}
            progressPercentage={progressPercentage}
            setProgressPercentage={setProgressPercentage}
            refreshQuota={refreshQuota}
            flap={flap}
            isBatch={isBatch} 
            user={user}
          />
        </TabPanel>
      </Tabs>}
      
      
      {loading && (
        <div className='loader_container'>
          <div className="preloader">
            <span className="loader"></span>
          </div>
        </div>
      )}
      {progressLoading && (
        <ProgressBar done={parseInt(progressPercentage)} />

      )}



    </div>
  );
};

export default Home;
